import { ReactNode } from "react";
import { FormAddon } from "../../common/form/Form";
import CollateralForm, { Props as CollateralFormProps } from "./CollateralForm";
import CollateralFormInput from "./CollateralFormInput";

type Props = Omit<CollateralFormProps, "children"> & {
  onCollateralAmountChange: (amount: string) => void;
  onRedeemableAmountChange: (amount: string) => void;
  collateralAmount: string;
  redeemableAmount: string;
  connected: boolean;
  children?: ReactNode;
};

const FromCollateralForm = ({
  onCollateralAmountChange,
  onRedeemableAmountChange,
  collateralAmount,
  redeemableAmount,
  connected,
  children,
  ...formProps
}: Props) => {
  return (
    <CollateralForm {...formProps}>
      {({ collateral, redeemable }) => {
        return (
          <>
            <CollateralFormInput
              id="collateral-amount-input"
              name="collateral-amount"
              label="From"
              value={collateralAmount}
              handleChange={onCollateralAmountChange}
              maxButtonEnabled={true}
              connected={connected}
              tokenInfo={collateral}
            />
            {children ? (
              <FormAddon className="CollateralForm">{children}</FormAddon>
            ) : null}
            <CollateralFormInput
              id="redeemable-amount-input"
              name="redeemable-amount"
              label="To"
              value={redeemableAmount}
              handleChange={onRedeemableAmountChange}
              maxButtonEnabled={false}
              connected={connected}
              tokenInfo={redeemable}
            />
          </>
        );
      }}
    </CollateralForm>
  );
};

export default FromCollateralForm;
